import { FC, useContext } from "react";
import LayoutSideBarComponentProps from "./layout_side_bar.component.props";
import { useLocation, useNavigate } from "react-router-dom";
import routes from "../../../../routes/Routes";
import di from "../../../../../dependency_injection";
import LogoutUseCase, { LogoutUseCaseName } from "../../../../../domain/use_cases/auth/LogoutUseCase";
import UserContext from "../../../../providers/user/UserContext";
import UserContextType from "../../../../../domain/providers/user/UserContextType";
import LocalizationContext from "../../../../providers/localization/LocalizationContext";
import LocalizationContextType from "../../../../../domain/providers/localization/LocalizationContextType";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css'; // Estilos por defecto
import KeyWordLocalization from "../../../../utils/KeyWordLocalization";



const _SideBarOption: FC<{
    icon: React.ReactElement;
    title: string;
    description?: string;
    active?: boolean;
    onClick?: () => void;
    showTooltip?: boolean;}> = ({ icon, title, description,active, onClick, showTooltip }) => {
    const content = (
        <div
            className={`sidebar_option ${onClick && 'hover'} ${active && 'active'}`}
            onClick={onClick}
        >
            <div className="sidebar_option_icon">{icon}</div>
            {!showTooltip && <div className="sidebar_option_text">{title}</div>}
        </div>
    );
    const tooltipContent = (
        <div style={{ maxWidth: 400 }}>
            <div style={{ fontWeight: "bold", marginBottom: 4 }}>{title}</div>
            {description && <div style={{ fontSize: "0.85rem", color: "#ccc" }}>{description}</div>}
        </div>
    );
    return showTooltip ? (
        <Tippy 
        content={tooltipContent} placement="right" animation="shift-away" delay={[500, 0]}>
            <div>{content}</div>
        </Tippy>
    ) : (
        content
    );
};


const LayoutSideBarComponent: FC<LayoutSideBarComponentProps> = ({ open, setOpen }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { user } = useContext(UserContext) as UserContextType;
    const { i18n } = useContext(LocalizationContext) as LocalizationContextType;

    const _handleLogout = async () => {
        await di.get<LogoutUseCase>(LogoutUseCaseName).call();
        navigate(routes.login.relativePath);
    }

    const routesToUse:{
        route: any; 
        icon: React.ReactElement;
        description: string;
    }[] = [
        {
            route: routes.home,
            icon: <span className="material-symbols-outlined">dashboard</span>,
            description: i18n(KeyWordLocalization.dashboard_description)
        },
        {
            route: routes.agent_list,
            icon: <span className="material-symbols-outlined">smart_toy</span>,
            description: i18n(KeyWordLocalization.scorecard_description)
        },
        {
            route: routes.human_agent_list,
            icon: <span className="material-symbols-outlined">people</span>,
            description: i18n(KeyWordLocalization.team_description)
        },
        {
            route: routes.ranking_human_agents,
            icon: <span className="material-symbols-outlined">leaderboard</span>,
            description: i18n(KeyWordLocalization.ranking_description)
        },
        {
            route: routes.qa_resumes_list,
            icon: <span className="material-symbols-outlined">call</span>,
            description: i18n(KeyWordLocalization.qa_description)
        }
    ];
    

    const isSamePath = (path: string) => location.pathname === path;
    return <div className="layout_sidebar_component">
        {open && <div className="bg_drop" onClick={() => setOpen(false)}></div>}
        <div className="content_sidebar">
            <div className="flex-grow-1">
                <div className="img_icon">
                    <img src="/assets/logo/short_yellow.png" className="closed" alt="" />
                    <img src="/assets/logo/long_yellow_white.png" alt="" className="open" />
                </div>
                {routesToUse.filter(route => route.route.auth(user)).map(route =>
                    <_SideBarOption
                        key={route.route.relativePath}
                        icon={route.icon}
                        active={isSamePath(route.route.relativePath)}
                        onClick={() => navigate(route.route.relativePath)}
                        title={i18n(route.route.title ?? "")}
                        description={route.description}
                        showTooltip={!open}
                    />
                )}
            </div>
            <_SideBarOption icon={<span className="material-symbols-outlined">logout</span>} onClick={_handleLogout} title="Logout" showTooltip={!open} />
        </div>
    </div>
}

export default LayoutSideBarComponent;